import React from "react";
import Lottie from "lottie-react";
import loadingAnimation from "../../assets/animation/loading.json";
import "./ui.scss";

const Loader = ({ text, animationSize, containerHeight }) => {
  return (
    <div
      className="loader-container"
      role="status"
      aria-label="Loading"
      style={{ height: `${containerHeight}px` }} // Dynamically set container height
    >
      <Lottie
        animationData={loadingAnimation}
        loop={true}
        style={{ width: `${animationSize}px`, height: `${animationSize}px` }} // Dynamically set animation size
      />
      {text && <p className="warning-text">{text}</p>}
    </div>
  );
};

export default Loader;
